const SET_OFFSET_HISTORY = "SET_OFFSET_HISTORY";

const createState = () => {
  return {
    // 相杀记录（打开相杀dialog时应当从这里获取信息）
    offsetHistory: {
      invoice: [],
      revenue: [],
      other: [],
      payAmount: 0,
    },
  }
};

export default {
  namespaced: true,
  state: createState(),
  getters: {},
  mutations:{
    [SET_OFFSET_HISTORY](state, payload) {
      state.offsetHistory = payload;
    },
  },
  actions: {
    setOffsetHistory({ commit }, payload) {
      commit(SET_OFFSET_HISTORY, payload);
    },
  }
};
